export function handleUnauthorisedError(error) {
  return new Promise((resolve, reject) => {
    const errorState = error.response;

    if (errorState) {
      if ([401, 403].indexOf(errorState.status) !== -1) {
        //auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        localStorage.clear();
        sessionStorage.clear();
        window.location = "/logout";
      }

      const error = errorState && errorState.message;
      reject(error);
    }

    resolve(errorState);
  });
}
